import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import { mergeMap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class CommonHttpService {
  public userInfo: any;
  public IP: any;

  constructor(
    private _http: HttpClient
  ) {

  }

  private isLoadingSub$ = new BehaviorSubject<boolean>(false);

  public isLoading$ = this.isLoadingSub$.asObservable();

  // private toggleLoadingState(state: boolean) {
  //   this.isLoadingSub$.next(state);
  // }

  //private loading: boolean = false;

  setLoading(loading: boolean) {
    //console.log("loader change:", loading);
    // this.loading = loading;
    this.isLoadingSub$.next(loading);
  }

  getLoading(): Observable<boolean> {
    //return of(this.loading);
    return this.isLoading$;
  }

  public get(url: string, headers: any = {}, params: any = {}): Observable<any> {
    const config = {
      params,
      headers: new HttpHeaders({
        ...headers
      })
    };
    return this._http.get(url, config)
      .pipe(
        mergeMap((response: any) => {
          return of(response);
        })
      );
  }

  public post(url: string, data: any = {}, headers: any = {}, params: any = {}): Observable<any> {
    const config = {
      headers: new HttpHeaders({
        ...headers
      })
    };
    return this._http.post(url, data, config)
      .pipe(
        mergeMap((response: any) => {
          return of(response);
        })
      );
  }

  public delete(url: string, data: any = {}, headers: any = {}, params: any = {}): Observable<any> {
    const config = {
      body: data,
      headers: new HttpHeaders({
        ...headers
      })
    };

    return this._http.request('DELETE', url, config).pipe(
      mergeMap((response: any) => {
        return of(response);
      })
    );
    // return this._http.delete(url, data)
    //   .pipe(
    //     mergeMap((response: any) => {
    //       return of(response);
    //     })
    //   );
  }

}



